import { usePlatformBanners } from "@/hooks/usePlatformBanners";

const SEVERITY_CLASS: Record<string, string> = {
  info: "bg-blue-600 text-white",
  success: "bg-emerald-600 text-white",
  warning: "bg-amber-500 text-black",
};

/**
 * Renderiza banners de plataforma ativos no topo do Public.
 * Feature entregue via Admin /broadcast (M2.5 F4). Sem este consumer
 * os banners seriam invisíveis ao usuário final — P1 do code review.
 */
export function PlatformBannerDisplay() {
  const { data: banners = [] } = usePlatformBanners();

  if (banners.length === 0) return null;

  return (
    <div className="flex flex-col">
      {banners.map((b) => (
        <div
          key={b.id}
          className={`w-full px-4 py-2 text-sm text-center ${
            SEVERITY_CLASS[b.severity] ?? SEVERITY_CLASS.info
          }`}
          role="status"
        >
          <strong className="mr-2">{b.title}</strong>
          {b.body && <span className="opacity-90">{b.body}</span>}
          {b.cta_text && b.cta_url && (
            <a
              href={b.cta_url}
              className="ml-3 underline font-medium"
              target="_blank"
              rel="noreferrer"
            >
              {b.cta_text}
            </a>
          )}
        </div>
      ))}
    </div>
  );
}
